import React from "react";
import { useSelector } from "react-redux";
import { useIntl, FormattedMessage } from "react-intl";

import { TranslationsProvider } from "@learningblocks/simulations/shared-components";

import { fetchTranslations } from "./locales/config";
import styles from "./styles.module.scss";

/**
 * Results59 - A functional component to display results in different categories.
 *
 * This component renders results based on data fetched from the Redux store.
 * It specifically handles the display of petri dish images for different types
 * such as 'lb', 'lb-amp', and 'lb-amp-ara'.
 *
 * @param {Object} props - Props passed to the component.
 * @param {string} props.component_type - Type of the component to fetch data for.
 */
const Results59 = (props) => {
  // Fetching data from the Redux store based on the component type
  const data = useSelector((state) => state.petridish[props.component_type]);
  const intl = useIntl();

  return (
    <div className={styles.predictionResults}>
      <div className={styles.wrapper}>
        {/* Display for LB plate */}
        <div>
          <div className={styles.sliderResults}>
            <label
              htmlFor="pp-img-control"
              style={{
                margin: "0px -1.5px 4px 1.5px",
                display: "block",
              }}
              aria-label={intl.formatMessage({
                id: "P minus | P plus",
                defaultMessage: "P minus | P plus",
                description: "",
              })}
            >
              P- | P+
            </label>
            <div
              id="pp-img-control"
              style={{
                display: "flex",
              }}
            >
              <div>
                <img
                  draggable="false"
                  src={
                    require(`./img/pminus/${data["lb"]["pminus"]}.svg`).default
                  }
                  alt=""
                />
              </div>
              <div>
                <img
                  draggable="false"
                  src={
                    require(`./img/pplus/${data["lb"]["pplus"]}.svg`).default
                  }
                  alt=""
                />
              </div>
            </div>
            <div className={styles.label}>
              <FormattedMessage
                id="LB plate"
                defaultMessage="LB plate"
                description=""
              />
            </div>
          </div>
        </div>
        {/* Display for LB/amp plate */}
        <div>
          <div className={styles.sliderResults}>
            <label
              htmlFor="pp-img-control-2"
              style={{
                margin: "0px -1.5px 4px 1.5px",
                display: "block",
              }}
              aria-label={intl.formatMessage({
                id: "P minus | P plus",
                defaultMessage: "P minus | P plus",
                description: "",
              })}
            >
              P- | P+
            </label>
            <div
              id="pp-img-control-2"
              style={{
                display: "flex",
              }}
            >
              <div>
                <img
                  draggable="false"
                  src={
                    require(`./img/pminus/${data["lb-amp"]["pminus"]}.svg`)
                      .default
                  }
                  alt=""
                />
              </div>
              <div>
                <img
                  draggable="false"
                  src={
                    require(`./img/pplus/${data["lb-amp"]["pplus"]}.svg`)
                      .default
                  }
                  alt=""
                />
              </div>
            </div>
            <div className={styles.label}>
              <FormattedMessage
                id="LB/amp plate"
                defaultMessage="LB/amp plate"
                description=""
              />
            </div>
          </div>
        </div>
        {/* Display for LB/amp/ara plate */}
        <div>
          <div className={styles.sliderResults}>
            <label
              htmlFor="pp-img-control-2"
              style={{
                margin: "0px -1.5px 4px 1.5px",
                display: "block",
              }}
              aria-label={intl.formatMessage({
                id: "P plus",
                defaultMessage: "P plus",
                description: "",
              })}
            >
              P+
            </label>
            <div
              style={{
                display: "flex",
              }}
            >
              <div>
                <img
                  id="pp-img-control-2"
                  width="100"
                  draggable="false"
                  src={
                    require(
                      `./img/lb-amp-ara/${
                        data["lb-amp-ara"]["pplus"] == 0
                          ? "default"
                          : data["lb-amp-ara"]["type"] +
                            "-" +
                            data["lb-amp-ara"]["pplus"]
                      }.svg`
                    ).default
                  }
                  alt=""
                />
              </div>
            </div>
            <div className={styles.label}>
              <FormattedMessage
                id="LB/amp/ara plate"
                defaultMessage="LB/amp/ara plate"
                description=""
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default (props) => (
  <TranslationsProvider fetchTranslations={fetchTranslations}>
    <Results59 {...props} />
  </TranslationsProvider>
);
